import _ from "lodash"

export const answerMap = Object.freeze({
    YES: true,
    NO: false,
})

export const filterConditions = (conditionalAttr, merkmal) => {
    return Object.entries(_.omit(conditionalAttr, ["isActive"])).reduce(
        (filteredConditions, [value, conditions]) => {
            if (conditions.some((condition) => condition.id === merkmal.id)) {
                const targetValue = answerMap.hasOwnProperty(value)
                    ? answerMap[value]
                    : value
                filteredConditions.push(targetValue)
            }
            return filteredConditions
        },
        [],
    )
}

export const checkConditionalMerkmal = (
    merkmal,
    sections,
    getDataFromPointer,
) => {
    if (merkmal?.conditionalattribute) return true

    let conditionExistsForThisId = false

    const isConditionSatisfied = sections.some((questionaire) =>
        questionaire?.connections?.some((connection) => {
            const conditionalAttr =
                connection.origin?.conditionalattribute || {}

            const possibleTriggerValues = filterConditions(
                conditionalAttr,
                merkmal,
            )

            if (possibleTriggerValues.length > 0) {
                conditionExistsForThisId = true
                const actualValue = getDataFromPointer(
                    connection?.origin?.pointer,
                )
                return possibleTriggerValues.includes(actualValue)
            }
            return false
        }),
    )

    return conditionExistsForThisId ? isConditionSatisfied : true
}

/**
 * Checks if a specific merkmal is allowed to be shown/active based on
 * the conditional attributes of other merkmale within the same rubrik.
 * * @param {Object} targetMerkmal - The merkmal to check.
 * @param {Object} rubrik - The parent rubrik containing all merkmale.
 * @param {Function} getDataFromPointer - Helper to fetch current form values.
 * @param {Number} index - The current index of the rubrik object.
 * @returns {boolean}
 */
export const checkConditionalMerkmalInRubrik = (
    targetMerkmal,
    rubrik,
    getDataFromPointer,
    index
) => {
    const targetId = targetMerkmal.id
    const conditionalAttributes = rubrik.children.filter(
        (m) => m.conditionalattribute,
    )

    const parentConditions = conditionalAttributes.filter((parent) => {
        return Object.values(parent.conditionalattribute).some((val) => {
            return (
                Array.isArray(val) && val.some((item) => item.id === targetId)
            )
        })
    })

    if (parentConditions.length === 0) {
        return true
    }
    
    return parentConditions.some((parent) => {
        const currentValue = getDataFromPointer(parent.pointer.replace("[i]", index))
        const mapping = parent.conditionalattribute
        const affectedIdsForCurrentValue = mapping[currentValue] || []
        return affectedIdsForCurrentValue.some((item) => item.id === targetId)
    })
}
